import { axios } from '@Root/API'

export const getInstitutions = () => {
	return axios.get('data-institutions-for-select')
}
